import React from 'react';
import { Typography } from '@mui/material';
import clsx from 'clsx';
import './MultiSelectOption.scss';
import { ReactComponent as CheckIcon } from '../../../assets/onboarding/check.svg';
import { ReactComponent as UncheckIcon } from '../../../assets/onboarding/uncheck.svg';

interface MultiSelectOptionProps {
  value: string;
  option: string;
  selectedValues: string[];
  handleSelect: (value: string) => void;
  showTextInput?: boolean;
  textInputValue?: string;
  setTextInputValue?: (value: string) => void;
  className?: string;
  textClassName?: string;
  placeholder?: string;
}

export const MultiSelectOption: React.FC<MultiSelectOptionProps> = ({
  value,
  option,
  selectedValues,
  handleSelect,
  showTextInput = false,
  textInputValue,
  setTextInputValue,
  className,
  textClassName,
  placeholder,
}) => {
  return (
    <>
      <div
        key={value}
        className={clsx('multi-select-option', className, {
          'multi-select-option--selected': selectedValues.includes(value),
        })}
        onClick={() => handleSelect(value)}
      >
        <Typography variant="body1" className={clsx('multi-select-option__text', textClassName)}>
          {option}
        </Typography>
        <div className="multi-select-option__check-container">
          {selectedValues.includes(value) ? (
            <CheckIcon color="inherit" />
          ) : (
            <UncheckIcon color="inherit" />
          )}
        </div>
      </div>
      {showTextInput && (
        <div className="multi-select-option">
          <input
            type="text"
            className="multi-select-option__input"
            value={textInputValue}
            onChange={(e) => setTextInputValue?.(e.target.value)}
            autoFocus
            placeholder={placeholder}
          />
        </div>
      )}
    </>
  );
};
